import { Absolute, Box, Button } from '@rsos/base-components';
import styled from '@rsos/theme/styled';

export const HeaderContainer = styled(Box).attrs({
  position: 'relative',
  align: 'center',
  width: '100%',
  backgroundColor: 'background',
  borderRadius: '5px',
  overflowY: 'hidden',
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
`;

export const StartChatContainer = styled(Box).attrs({
  height: '100%',
  horizontal: true,
  width: '100%',
})``;

export const StartChatButton = styled(Button).attrs({
  noMargin: true,
  size: 'med',
  grow: true,
  width: '100%',
})`
  border-radius: 5px;
  > div {
    grid-column-gap: 4px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const ConversationsContainer = styled(Box).attrs({
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
})`
  transition: flex 0.6s ease;
  position: relative;
`;

export const ChatContainer = styled(Box).attrs({
  borderTop: '1px solid',
  borderColor: 'lightLineDivider',
  flex: '1',
})``;

export const IconButtonsBox = styled.div`
  display: flex;
  gap: 8px;
`;

export const RedCircle = styled(Box).attrs({
  backgroundColor: 'lightDanger',
  borderRadius: '10px',
  height: '8px',
  mr: '4px',
  width: '8px',
  inline: true,
})``;

export const AbsoluteAllMessagesContainer = styled(Absolute).attrs({
  top: 0,
  left: 0,
  width: '100%',
})`
  height: 100%;
  border-radius: 5px;
`;
